<template>
  <div>
    <div v-if="currencyPlaceholder" class="input-wrapper currency">
      <div class="currency-box">
        £
      </div>
      <input
          class="form-control calc-form-control"
          type="number"
          :min="min"
          :max="max"
          :value="value"
          ref="currencyInput"
          @input="handleInput"
          @keyup="formatInputValue"
          :placeholder="placeholder"
      >
    </div>
    <div v-else class="input-wrapper">
      <input
        class="form-control calc-form-control"
        type="number"
        :min="min"
        :max="max"
        :value="value"
        @input="handleInput"
        :placeholder="placeholder"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    max: {
      type: Number
    },
    min: {
      type: Number,
      default: 0
    },
    currencyPlaceholder: {
      type: Boolean,
      default: false
    },
    placeholder: String
  },
  methods: {
    handleInput(e) {
      this.$emit('input', parseInt(e.target.value))
    },
    formatCurrencyInput(price) {
      //eslint-disable-next-line
      price.replace(/[\D\s\._\-]+/g, "");
      price = price ? parseInt( price, 10 ) : "";

      // console.log(price)

      if ( Number.isNaN(price) ) {
        return price = "";
      }

      // console.log(price.toLocaleString( "en-GB" ));

      // console.log(new Intl.NumberFormat('en-GB').format(price));

      return price
    },
    formatInputValue() {
      this.$refs.currencyInput.value = this.formatCurrencyInput(this.$refs.currencyInput.value)

    }
  }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  position: relative;
  .currency-box {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 55px;
    z-index: 1;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #b6b6b6;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    background-color: #323C43;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  input {
    padding-left: 44px;
  }
}
</style>
